import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Typography, Button } from '@material-ui/core';
import Paper from '@mui/material/Paper';
import BorrowIcon01 from '../../../../utils/assests/borrower-icon-01.png';
import BorrowIcon02 from '../../../../utils/assests/borrower-icon-02.png';
import BorrowIcon03 from '../../../../utils/assests/borrower-icon-03.png';
import BorrowIcon04 from '../../../../utils/assests/calendar-icon.png';
import BorrowIcon05 from '../../../../utils/assests/borrower-icon-04.png';
import BorrowIcon06 from '../../../../utils/assests/borrower-icon-05.png';

export default function BorrowerForm(props: any) {
  const { borrowerResponse, handleKnowMore, errorMessage } = props;
  const Item = styled(Paper)(({ theme }: any) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
  return (
    <>
      {/* {borrowerResponse && borrowerResponse?.status ?
            Object.entries(borrowerResponse?.data.portfolio_summary).map(([key, value]: any) => {
                return (
                    <>
                        {key !== 'investments_for_piechart' && <><div className='row-one'>
                            <div className='price'>
                                {key}
                            </div>
                            <div className='date'>{value}</div>
                        </div> <hr />
                        </>}

                    </>
                );
            }) : errorMessage} */}
      <Grid
        container
        spacing={3}
        marginBottom={2}
        justifyContent='center'
        className='innerCardStyle'
      >
        <Grid item xs={4}>
          <Paper>
            <img src={BorrowIcon01} alt='' />
            <Typography component='span'>total Borrower</Typography>
            <Typography>{borrowerResponse?.data?.portfolio_summary?.total_borrowers ? borrowerResponse?.data?.portfolio_summary?.total_borrowers : 0}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <Paper>
            <img src={BorrowIcon02} alt='' />
            <Typography component='span'>avg. investment</Typography>
            <Typography>
              <span className='rupeeIcon'>₹</span>{borrowerResponse?.data?.portfolio_summary?.avg_investment ? borrowerResponse?.data?.portfolio_summary?.avg_investment : 0}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <Paper>
            <img src={BorrowIcon03} alt='' />
            <Typography component='span'>avg. fair</Typography>
            <Typography>{borrowerResponse?.data?.portfolio_summary?.avg_foir ? borrowerResponse?.data?.portfolio_summary?.avg_foir : '-'}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <Paper>
            <img src={BorrowIcon04} alt='' />
            <Typography component='span'>avg. tenure</Typography>
            <Typography>{borrowerResponse?.data?.portfolio_summary?.avg_tenure ? borrowerResponse?.data?.portfolio_summary?.avg_tenure : '0'} months</Typography>
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <Paper>
            <img src={BorrowIcon05} alt='' />
            <Typography component='span'>avg. CBIL</Typography>
            <Typography>{borrowerResponse?.data?.portfolio_summary?.avg_cibil ? borrowerResponse?.data?.portfolio_summary?.avg_cibil : '-'}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <Paper>
            <img src={BorrowIcon06} alt='' />
            <Typography component='span'>avg. age</Typography>
            <Typography>{borrowerResponse?.data?.portfolio_summary?.avg_age ? borrowerResponse?.data?.portfolio_summary?.avg_age : '-'}</Typography>
          </Paper>
        </Grid>
        {/* <Grid item xs={12} className='text-center knowMoreGrid'>
          <Button
            onClick={handleKnowMore}
            variant='contained'
            className='btnWhite'
          >
            know more
          </Button>
        </Grid> */}
      </Grid>
     
    </>
  );
}